import { DeviceTypeMap } from './device-type-map';
import { PageData } from './page-data';
import { layerName } from './globals';
import { EmbedMutationRule, EmbedMutationType } from './embed-mutation-rule';

const dataLayer = (window[layerName] = window[layerName] ?? <PageData>{});

export { DeviceTypeMap, PageData, dataLayer, EmbedMutationRule, EmbedMutationType };
